import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })
export class FileStorageService {
  public url = '/api/filestorage';

  constructor(public http: HttpClient) {}

  public getPreSignedURL(key: string): Promise<any> {
    return this.http
      .get(`${this.url}/getpresignedurl?objectKey=${key}`)
      .toPromise()
      .then((a) => {
        return a;
      })
      .catch(this.handleError);
  }

  public getPreSignedURLs(keys: string[]): Promise<string[]> {
    return this.http
      .post(`${this.url}/getpresignedurls`, keys)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  openSourceInTab(objectKey) {
    this.getPreSignedURLs([objectKey]).then((urls) => window.open(urls[0], '_blank'));
  }

  public getDownloadFileUrl(key: string) {
    return `${this.url}/file/${key}`;
  }

  downloadFile(uri: any, extension: string) {
    return this.http.get(uri, { responseType: 'blob' }).subscribe(
      (x) => this.handleDownloadFile(x, extension),
      (error) => {
        console.log('Error downloading file');
      },
      () => {
        console.log('File downloaded');
      },
    );
  }

  public handleDownloadFile(blob, extension: string) {
    let filename = `image.${extension ? extension : 'png'}`;
    FileSaver.saveAs(blob, filename);
  }

  extractData(res: any) {
    return res;
  }

  private handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }

  public uploadFile(file): Promise<any> {
    let input = new FormData();
    input.append('files', file);
    input.append('lastModifiedDate', file.lastModifiedDate.getTime());

    return this.http.post('/api/filestorage/fileuploading?size=400', input).toPromise();
  }

  public uploadBannerFile(file): Promise<any> {
    let input = new FormData();
    input.append('files', file);
    input.append('lastModifiedDate', file.lastModifiedDate.getTime());

    return this.http.post('/api/filestorage/banner-image-upload?size=400', input).toPromise();
  }

  public deleteFile(filename): Promise<any> {
    return this.http.delete(`/api/filestorage`, { body: { filename } }).toPromise();
  }
}
